import { motion } from "framer-motion";
import Waveform from "@/components/Waveform";

export default function Story() {
  return (
    <div className="bg-ink min-h-screen" data-testid="story-page">
      <section className="relative min-h-[70vh] flex items-end overflow-hidden">
        <img src="https://images.unsplash.com/photo-1727094141271-9bea5bc8c757?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800"
          alt="runner" className="absolute inset-0 w-full h-full object-cover grayscale" />
        <div className="absolute inset-0 bg-ink/70" />
        <div className="relative container-sync pb-20 pt-40">
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.2 }} className="eyebrow mb-6">The meaning behind SYNC</motion.p>
          <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
            className="font-anton uppercase text-6xl sm:text-8xl leading-[0.85] max-w-4xl">
            Movement isn't just exercise. It's a mindset.
          </motion.h1>
        </div>
      </section>

      <section className="container-sync py-28 grid lg:grid-cols-2 gap-16">
        <div>
          <p className="eyebrow mb-6">What SYNC means</p>
          <p className="text-chalk/90 text-xl leading-[1.8]">
            The name SYNC represents being in sync with your body's movements, your heartbeat, the rhythm of
            the music, your lifestyle, and the constant desire to keep moving forward.
          </p>
          <ul className="mt-8 space-y-3 font-mono text-sm text-graphite uppercase tracking-wider">
            {["Your body's movements", "Your heartbeat", "The rhythm of the music", "Your personal lifestyle", "The desire to keep moving forward"].map((x) => (
              <li key={x} className="flex gap-3"><span className="text-pulse">/</span> {x}</li>
            ))}
          </ul>
        </div>
        <div>
          <p className="eyebrow mb-6">Our vision</p>
          <p className="text-chalk/90 text-xl leading-[1.8]">
            We're building more than a clothing brand. We're building a community centered on movement, music,
            and self-improvement — one that reaches people everywhere, at every pace.
          </p>
          <p className="text-graphite text-lg leading-[1.85] mt-6">
            Whether you're an experienced runner or someone simply walking to the corner store, SYNC is
            designed to make you feel empowered every time you wear it. Motivation. Confidence. Positive energy.
            That's the feeling we design for.
          </p>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-graphite mt-8" data-testid="story-location">
            <span className="text-pulse">/</span> Based in Atlanta, Georgia, USA
          </p>
        </div>
      </section>

      <section className="bg-chalk text-ink py-28">
        <div className="container-sync text-center">
          <Waveform color="rgb(var(--ink))" className="mb-12 max-w-3xl mx-auto" />
          <h2 className="font-anton uppercase text-5xl sm:text-7xl">This is SYNC.<br />Move with the beat.</h2>
          <a href="mailto:info@thesyncwear.com" data-testid="story-contact-link"
            className="inline-block mt-10 font-mono text-sm uppercase tracking-[0.2em] text-ink border-b-2 border-pulse pb-1 hover:text-pulse transition-colors">
            info@thesyncwear.com
          </a>
        </div>
      </section>
    </div>
  );
}
